import { Directive, HostListener } from '@angular/core';

/**
 * Diretiva que permite apenas números em um input.
 * Remove automaticamente qualquer caractere que não seja numérico.
 *
 * @example
 * <input appOnlyNumbers formControlName="code" />
 */
@Directive({
  selector: '[appOnlyNumbers]',
  standalone: false
})
export class OnlyNumbersDirective {
  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    // Remove qualquer caractere que não seja número
    input.value = input.value.replace(/[^0-9]/g, '');
  }
}
